{
  "clinicalNotes": "진료 노트",
  "noteType": "노트 유형",
  "author": "작성자",
  "dateTime": "날짜/시간",
  "content": "내용",
  "addNote": "노트 추가",
  "editNote": "노트 편집",
  "signNote": "노트 서명",
  "signed": "서명됨",
  "unsigned": "미서명",
  "types": {
    "progressNote": "경과 기록",
    "admissionNote": "입원 기록",
    "dischargeNote": "퇴원 기록",
    "consultNote": "자문 기록",
    "procedureNote": "시술 기록"
  },
  "editor": {
    "newNote": "새 노트",
    "titlePlaceholder": "노트 제목…",
    "create": "생성",
    "cancel": "취소",
    "cosignFilterLabel": "내가 부서명할 노트만 표시합니다",
    "emptyNoCosign": "부서명이 필요한 노트가 없습니다",
    "emptyNoNotes": "아직 노트가 없습니다",
    "emptySelection": "노트를 선택하거나 새로 만드십시오",
    "emptySelectionHint": "왼쪽 목록에서 선택하거나 \"+ 새 노트\"를 눌러 시작하십시오.",
    "unknownAuthor": "알 수 없음",
    "needsCosignBadge": "부서명 필요",
    "amendmentBanner": "노트 #{{parentId}}의 수정 — 사유: {{reason}}",
    "signedBanner": "{{name}} 님이 {{when}}에 서명함 — 이 노트는 읽기 전용입니다.",
    "signedByFallback": "의사",
    "saving": "저장 중…",
    "autoSaved": "자동 저장됨",
    "actions": {
      "saveDraft": "초안 저장",
      "signNote": "노트 서명",
      "amend": "수정",
      "cosign": "부서명",
      "printLabel": "노트 인쇄"
    },
    "copyForward": "이전 기록 이어쓰기",
    "copyForwardHint": "{{date}}에 서명된 기록을 가져옵니다 — 모든 항목을 검토하고 갱신하세요",
    "copiedForwardBadge": "이어쓴 기록"
  },
  "dialog": {
    "sign": {
      "title": "노트 서명",
      "body": "이 노트에 서명하시겠습니까? 이 작업은 취소할 수 없습니다. 서명 후 노트는 읽기 전용이 됩니다.",
      "cancel": "취소",
      "confirm": "서명 확인"
    },
    "amend": {
      "title": "노트 수정",
      "body": "이번 수정의 사유를 입력해 주십시오. 노트가 업데이트되고 수정됨으로 표시됩니다.",
      "reasonPlaceholder": "수정 사유…",
      "cancel": "취소",
      "confirm": "수정 확인"
    },
    "cosign": {
      "title": "노트 부서명",
      "body": "이 노트에 부서명하시겠습니까? 이는 노트 내용을 검토하고 동의함을 의미합니다.",
      "cancel": "취소",
      "confirm": "부서명 확인"
    }
  },
  "toast": {
    "created": "노트가 생성되었습니다",
    "createFailed": "노트 생성에 실패했습니다",
    "titleRequired": "노트 제목을 입력하십시오",
    "draftSaved": "초안이 저장되었습니다",
    "signed": "노트가 서명되었습니다",
    "signFailed": "노트 서명에 실패했습니다",
    "amended": "노트가 수정되었습니다",
    "amendFailed": "노트 수정에 실패했습니다",
    "amendReasonRequired": "수정 사유를 입력하십시오",
    "cosigned": "노트가 부서명되었습니다",
    "cosignFailed": "노트 부서명에 실패했습니다"
  },
  "status": {
    "draft": "초안",
    "unsigned": "미서명",
    "signed": "서명됨",
    "amended": "수정됨",
    "cosigned": "부서명됨",
    "cosignNeeded": "부서명 필요",
    "pendingSignature": "서명 대기",
    "addendum": "보충 기록",
    "cosignPending": "부서명 대기"
  },
  "worklist": {
    "title": "미서명 노트 워크리스트",
    "backToDashboard": "대시보드",
    "filtersHeading": "필터",
    "filterAllNoteTypes": "모든 노트 유형",
    "filterAllStatuses": "모든 상태",
    "filterAuthorPlaceholder": "작성자로 필터링…",
    "dateFromAria": "노트 시작일",
    "dateToAria": "노트 종료일",
    "columns": {
      "patient": "환자",
      "mrn": "MRN",
      "noteType": "노트 유형",
      "noteTitle": "제목",
      "author": "작성자",
      "created": "생성일",
      "status": "상태",
      "actions": "작업"
    },
    "actions": {
      "signSelected": "선택 항목 서명({{count}})",
      "signing": "서명 중…",
      "open": "열기",
      "refresh": "새로고침"
    },
    "loading": "노트를 불러오는 중…",
    "empty": "미서명 노트가 없습니다",
    "loadError": "미서명 기록 로드 실패",
    "retry": "다시 시도",
    "toast": {
      "noneSelected": "선택된 노트가 없습니다",
      "signed_one": "{{count}}개 노트가 서명되었습니다",
      "signed_other": "{{count}}개 노트가 서명되었습니다",
      "signFailed": "일부 노트의 서명에 실패했습니다",
      "partiallySigned_one": "{{count}}개 노트 서명됨, {{failed}}개 실패",
      "partiallySigned_other": "{{count}}개 노트 서명됨, {{failed}}개 실패"
    }
  },
  "type": {
    "progress": "경과 기록",
    "historyPhysical": "H&P",
    "admission": "입원 기록",
    "discharge": "퇴원 요약",
    "consult": "자문",
    "procedure": "시술 기록",
    "operative": "수술 기록",
    "nursing": "간호 기록"
  },
  "template": {
    "list": {
      "title": "노트 템플릿",
      "backToDashboard": "대시보드",
      "newButton": "새 템플릿",
      "columns": {
        "name": "이름",
        "noteType": "노트 유형",
        "specialty": "진료과",
        "sections": "섹션",
        "status": "상태",
        "actions": "작업"
      },
      "active": "활성",
      "inactive": "비활성",
      "loading": "템플릿을 불러오는 중…",
      "empty": "템플릿이 없습니다. 새로 만들어 시작하십시오.",
      "previewTitle": "템플릿 미리보기: {{name}}",
      "emptySection": "(비어 있음)",
      "tooltips": {
        "preview": "미리보기",
        "edit": "편집",
        "activate": "활성화",
        "deactivate": "비활성화"
      },
      "toast": {
        "statusUpdated": "템플릿 상태가 업데이트되었습니다"
      }
    },
    "form": {
      "editTitle": "템플릿 편집",
      "createTitle": "템플릿 생성",
      "fields": {
        "name": "템플릿 이름",
        "noteType": "노트 유형",
        "specialty": "진료과",
        "sections": "섹션"
      },
      "required": "*",
      "namePlaceholder": "예: 표준 경과 기록",
      "selectNoteType": "유형 선택…",
      "selectSpecialty": "진료과 선택…",
      "addSection": "섹션 추가",
      "sectionNamePlaceholder": "섹션 이름 (예: 주호소)",
      "sectionDefaultPlaceholder": "이 섹션의 기본 내용…",
      "cancel": "취소",
      "create": "템플릿 생성",
      "update": "템플릿 업데이트",
      "toast": {
        "created": "템플릿이 생성되었습니다",
        "updated": "템플릿이 업데이트되었습니다",
        "saveFailed": "템플릿 저장에 실패했습니다",
        "nameAndTypeRequired": "이름과 노트 유형은 필수입니다",
        "atLeastOneSection": "섹션이 최소 한 개 필요합니다"
      }
    },
    "specialty": {
      "general": "일반의학",
      "internalMedicine": "내과",
      "surgery": "외과",
      "pediatrics": "소아과",
      "cardiology": "순환기내과",
      "neurology": "신경과",
      "orthopedics": "정형외과",
      "emergencyMedicine": "응급의학과"
    },
    "scope": {
      "personal": "개인",
      "group": "그룹",
      "global": "전체"
    },
    "state": {
      "draft": "초안",
      "published": "게시됨"
    }
  },
  "components": {
    "clinicalNoteEditor": {
      "bold": "굵게",
      "italic": "기울임꼴",
      "list": "목록",
      "templates": "템플릿 / 스마트 문구",
      "saved": "저장됨 {{time}}",
      "notSaved": "저장되지 않음",
      "charactersLabel": "자",
      "save": "{{noteType}} 저장",
      "placeholder": "{{noteType}} 입력을 시작하세요… \".\"을 입력하면 스마트 문구가 표시됩니다.",
      "smartPhrases": {
        "patientName": "환자명",
        "mrn": "등록번호",
        "dateOfBirth": "생년월일",
        "allergies": "알레르기",
        "vitals": "활력징후",
        "medications": "투약",
        "problemList": "문제 목록"
      }
    }
  }
}
